import { AxiosService } from 'services';
export function PostBrandService(formData) {

  return AxiosService().post('brand/register', formData)
    .then(function (response) {
      return response;
    }).catch(function (error) {
      return error;
    });
}
